export default "__VITE_ASSET__BlzPVyKE__"